import { IconProps } from "@lib/icons/types"
import { forwardRef } from "react"

export const FireIcon = forwardRef<SVGSVGElement, IconProps>((props, ref) => {
  const { className, ...otherProps } = props
  return (
    <svg
      ref={ref}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...otherProps}
    >
      <path
        d="M20.2789 14.9639C19.6414 8.26202 10.5284 0.375 10.5284 0.375C10.5284 0.375 13.0539 6.76635 7.5861 13.1659C7.5861 13.1659 6.98129 11.2861 7.30004 8.9976C5.34668 10.9918 3.38514 13.0596 3.72023 16.5495C3.98995 19.3692 5.64091 21.7313 7.94572 23.0144C8.24812 22.6712 8.55052 22.3361 8.85293 22.0091C10.6183 19.9577 12.2121 16.5822 12.5472 13.9587C12.5472 13.9587 14.5741 18.3803 15.4404 23.325C18.5871 21.8947 20.6303 18.601 20.2789 14.9639Z"
        fill="currentColor"
      />
    </svg>
  )
})
